import React, { createContext, useContext, useState } from "react";

const AIChatContext = createContext(null);

export function AIChatProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [initialPrompt, setInitialPrompt] = useState("");

  const openChat = (prompt = "") => {
    if (prompt) {
      setInitialPrompt(prompt);
    }

    setOpen(true);
  };

  const closeChat = () => {
    setOpen(false);
  };

  return (
    <AIChatContext.Provider
      value={{
        open,
        setOpen,
        initialPrompt,
        setInitialPrompt,
        openChat,
        closeChat,
      }}
    >
      {children}
    </AIChatContext.Provider>
  );
}

export function useAIChat() {
  const context = useContext(AIChatContext);

  if (!context) {
    throw new Error("useAIChat must be used inside AIChatProvider");
  }

  return context;
}